module.exports = __webpack_public_path__ + "img/CM-BS-24-GMC-Modern.248bd920.jpg";